// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1GCXH","log":"ModalInventoryLogs_log__1yImo","date":"ModalInventoryLogs_date__26KdF","userName":"ModalInventoryLogs_userName__2Ayqp"};